import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useWishlist } from "@/context/WishlistContext";

export const WishButton = ({ id, className = "" }) => {
  const { has, toggle } = useWishlist();
  const on = has(id);
  return (
    <button
      type="button"
      data-testid={`wishlist-toggle-${id}`}
      aria-label={on ? "Rimuovi dai preferiti" : "Aggiungi ai preferiti"}
      onClick={(e) => { e.preventDefault(); toggle(id); toast.success(on ? "Rimosso dai preferiti" : "Aggiunto ai preferiti"); }}
      className={`bg-white border border-[#0F0F0F] p-2 hover:scale-110 transition-transform ${className}`}
    >
      <Heart size={16} strokeWidth={1.5} className={on ? "fill-[#FF3333] text-[#FF3333]" : ""} />
    </button>
  );
};
